<template>
	<div>
		<el-card shadow="never">
			<div slot="header" class="clearfix">
				<h4>基本信息</h4>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="培训名称" prop="name" :label-width="labelWidth">
					<el-input style="width: 400px;" v-model="ruleForm.name"
						placeholder="请输入1-30个字符，仅支持字母/汉字/数字"></el-input>
				</el-form-item>
				<el-form-item label="培训分类" prop="train_cate_uuid" :label-width="labelWidth">
					<el-select style="width: 400px;" v-model="ruleForm.train_cate_uuid" placeholder="请选择培训分类">
						<el-option v-for="item in level" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="培训开始时间" prop="begin_time" :label-width="labelWidth">
					<el-date-picker style="width: 400px;" value-format='yyyy-MM-dd' format='yyyy-MM-dd'
						v-model="ruleForm.begin_time" type="datetime" placeholder="选择培训开始时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="培训结束时间" prop="end_time" :label-width="labelWidth">
					<el-date-picker style="width: 400px;" value-format='yyyy-MM-dd' format='yyyy-MM-dd'
						v-model="ruleForm.end_time" type="datetime" placeholder="选择培训结束时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="报名开始时间" prop="sign_begin_time" :label-width="labelWidth">
					<el-date-picker style="width: 400px;" v-model="ruleForm.sign_begin_time" type="datetime"
						value-format='yyyy-MM-dd HH:mm' format='yyyy-MM-dd HH:mm' placeholder="选择报名开始时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="报名结束时间" prop="sign_end_time" :label-width="labelWidth">
					<el-date-picker style="width: 400px;" v-model="ruleForm.sign_end_time" type="datetime"
						value-format='yyyy-MM-dd HH:mm' format='yyyy-MM-dd HH:mm' placeholder="选择报名结束时间">
					</el-date-picker>
				</el-form-item>

				<el-form-item label="培训地点" prop="address" :label-width="labelWidth">
					<el-input style="width: 400px;" v-model="ruleForm.address"
						placeholder="请输入1-50个字符，仅支持字母/汉字/数字"></el-input>
				</el-form-item>
				<el-form-item label="培训人数" prop="num" :label-width="labelWidth">
					<el-input style="width: 400px;" v-model="ruleForm.num" type='number'
						placeholder="请输入大于0的数字"></el-input>
				</el-form-item>
				<el-form-item label="最低报名会员等级" prop="member_uuid" :label-width="labelWidth">
					<el-select style="width: 400px;" v-model="ruleForm.member_uuid" placeholder="请选择最低报名会员等级">
						<el-option v-for="item in members" :key="item.uuid" :label="item.name" :value="item.uuid">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="支持支付方式" prop="pay_type" :label-width="labelWidth">
					<el-radio-group v-model="ruleForm.pay_type" @change="payTypeChange">
						<el-radio :label="1">积分</el-radio>
						<el-radio :label="2">微信</el-radio>
						<!-- <el-radio :label="3">全选</el-radio> -->
						<el-radio :label="3">免费培训</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="微信报名价格" v-if="ruleForm.pay_type ==2" prop="price" :label-width="labelWidth">
					<el-input style="width: 400px;" type="number" placeholder="请输入大于0的数字"
						v-model="ruleForm.price"></el-input>
				</el-form-item>
				<el-form-item label="积分报名价格" v-if="ruleForm.pay_type ==1" prop="score" :label-width="labelWidth">
					<el-input style="width: 400px;" type="number" placeholder="请输入大于0的数字"
						v-model="ruleForm.score"></el-input>
				</el-form-item>
				<el-form-item label="取消报名联系电话" prop="cancel_phone" :label-width="labelWidth">
					<el-input style="width: 400px;" placeholder="请输入取消报名联系电话"
						v-model="ruleForm.cancel_phone"></el-input>
				</el-form-item>
				<el-form-item label="是否有奖励积分" prop="is_get_score" :label-width="labelWidth">
					<el-radio-group v-model="ruleForm.is_get_score" @change="getScoreChange">
						<el-radio :label="2">无积分奖励</el-radio>
						<el-radio :label="1">有积分奖励</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="积分奖励数额" v-if="ruleForm.is_get_score == 1" prop="get_score"
					:label-width="labelWidth">
					<el-input style="width: 400px;" placeholder="请输入大于0的数字" v-model="ruleForm.get_score"></el-input>
				</el-form-item>
				<el-form-item label="培训权重" prop="weight" :label-width="labelWidth">
					<el-input style="width: 400px;" placeholder="请输入大于0的数字" v-model="ruleForm.weight"></el-input>
					<div style="color: #999;">权重数字越大排序越靠前，子级分类仅跟同一父级下比较</div>
				</el-form-item>
				<el-form-item label="培训封面" prop="img" :label-width="labelWidth">
					<ImageUpload :limit='1' @input='imageUpload' :onloadImageList='onloadImageList'></ImageUpload>
					<div style="color: #999;">支持扩展名：.png .jpg .jpeg 请上传小于20M图片，建议上传16:9格式图片</div>
				</el-form-item>
				<el-form-item label="培训介绍" prop="desc" :label-width="labelWidth">
					<QuillEditor :value="desc" @input='editorInput'></QuillEditor>
				</el-form-item>
			</el-form>
		</el-card>
		<el-card shadow="never" style="margin-top: 10px;" class="flex flex-c">
			<el-button type="primary" style="width: 150px;" plain @click="resetForm('ruleForm')">返回</el-button>
			<el-button type="primary" style="width: 150px;" @click="submitForm('ruleForm')">保存</el-button>
		</el-card>


	</div>
</template>

<script>
	import QuillEditor from '@/components/quill-editor.vue'
	import ImageUpload from "../../components/ImageUpload.vue";
	import {
		imgDomain
	} from '@/configs/env';
	import operations from "@/mixins/operations";
	import CommonPagination from "@/components/CommonPagination";
	import {
		addTrain,
		updateTrain,
		getTrainDetail,
		getTrainCateList
	} from "@/api/train"
	import {
		getMemberList
	} from "@/api/user"
	import {
		mapState
	} from "vuex";

	export default {
		name: "userDetail",
		mixins: [operations],
		data() {
			return {
				labelWidth: '150px',
				radio: '2',
				activeTab: 'first',
				imgDomain,
				total: 0,
				page_size: 9,
				page_index: 1,
				doubaoList: [],
				num: 1,
				detailObject: {},
				detailUserId: '',
				selectedTabIndex: "all",
				activeName: '1',
				user_uuid: '',
				total1: 0,
				page_index1: 1,
				page_size1: 9,
				hisLists: [],
				value: '500',
				ruleForm: {
					uuid: '',
					name: '',
					train_cate_uuid: '',
					num: '',
					member_uuid: '',
					address: '',
					avatar: '',
					begin_time: '',
					sign_end_time: '',
					end_time: '',
					sign_begin_time: '',
					pay_type: '',
					cancel_phone: '',
					price: '',
					score: '',
					is_get_score: 1,
					get_score: '',
					weight: '',
					img: '',
					desc: ''
				},
				rules: {
					price:[
						{
							// 匹配大于0的数字（包括整数和小数）
							pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
							message: '必须输入大于0的数字',
							trigger: ['blur', 'change']
						}
					],
					score:[
						{
							// 匹配大于0的数字（包括整数和小数）
							pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
							message: '必须输入大于0的数字',
							trigger: ['blur', 'change']
						}
					],
					name: [{
							required: true,
							message: '请输入培训名称',
							trigger: 'blur'
						},
						{
							min: 1,
							max: 30,
							message: '请输入1-30位字母、数字、汉字',
							trigger: 'blur'
						}
					],
					train_cate_uuid: [{
						required: true,
						message: '请选择培训分类',
						trigger: 'change'
					}],
					begin_time: [{
						required: true,
						message: '请选择培训开始时间',
						trigger: 'change'
					}],
					end_time: [{
						required: true,
						message: '请选择培训结束时间',
						trigger: 'change'
					}],
					sign_begin_time: [{
						required: true,
						message: '请选择报名开始时间',
						trigger: 'change'
					}],
					sign_end_time: [{
						required: true,
						message: '请选择报名结束时间',
						trigger: 'change'
					}],
					address: [{
						required: true,
						message: '请输入培训地点',
						trigger: 'change'
					}, {
						min: 1,
						max: 50,
						message: '请输入1-50位字母、数字、汉字',
						trigger: 'blur'
					}],
					num: [{
						required: true,
						message: '请输入培训人数',
						trigger: 'blur'
					}, {
						// 匹配大于0的数字（包括整数和小数）
						pattern: /^(0*[1-9]\d*(\.\d+)?|0+\.\d*[1-9]\d*)$/,
						message: '必须输入大于0的数字',
						trigger: ['blur', 'change']
					}],
					member_uuid: [{
						required: true,
						message: '请选择最低报名会员等级',
						trigger: 'change'
					}],
					pay_type: [{
						required: true,
						message: '请选择支持支付方式',
						trigger: 'change'
					}],
					cancel_phone: [{
						required: true,
						message: '请输入取消报名联系电话',
						trigger: 'blur'
					}, {
						pattern: /^1[3-9]\d{9}$/,
						message: '手机号格式不正确',
						trigger: 'blur'
					}],
					weight: [{
						required: true,
						message: '请输入大于0的数字',
						trigger: 'blur'
					}],
					img: [{
						required: true,
						message: '请上传培训封面',
						trigger: 'blur'
					}],
					desc: [{
						required: true,
						message: '请输入培训介绍',
						trigger: 'blur'
					}],

				},
				level: [],
				onloadImageList: [],
				desc: '',
				members: []
			};
		},
		components: {
			CommonPagination,
			ImageUpload,
			QuillEditor
		},
		async mounted() {
			const uuid = this.$route.query.uuid
			this.user_uuid = uuid
			this.getTrainCateList()
			this.getMemberList()
			if (uuid) {
				this.ruleForm.uuid = uuid
				this.getTrainDetail(uuid);
			}
		},
		methods: {
			payTypeChange(e) {
				if (e == 1) {
					this.ruleForm.score = ''
				} else if (e == 2) {
					this.ruleForm.price = ''
				}
			},
			getScoreChange(e) {
				if (e == 1) {
					this.ruleForm.get_score = ''
				}
			},
			editorInput(e) {
				this.ruleForm.desc = e
			},
			imageUpload(e) {
				this.ruleForm.img = imgDomain + e[0]
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (!this.ruleForm.uuid) {
							this.addTrain()
						} else {
							this.updateTrain()
						}
					} else {
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
				this.goBack()
			},
			async getTrainCateList() {
				let postData = {
					page_size: 9999,
					page_index: 1
				};
				const {
					status,
					data
				} = await getTrainCateList(postData);
				if (status !== 200) return;
				this.level = data.result.data;
			},
			async getMemberList() {
				let postData = {
					page_size: 9999,
					page_index: 1
				};
				const {
					status,
					data
				} = await getMemberList(postData);
				if (status !== 200) return;
				this.members = data.result.data;
			},
			async addTrain() {
				const {
					status,
					data
				} = await addTrain({
					...this.ruleForm
				});
				if (status !== 200) return;
				this.$message.success('新增成功')
				this.goBack()
			},
			async updateTrain() {
				const {
					status,
					data
				} = await updateTrain({
					...this.ruleForm
				});
				if (status !== 200) return;
				this.$message.success('修改成功')
				this.goBack()
			},
			goBack() {
				this.$router.go(-1)
			},
			async getTrainDetail(uuid) {
				const {
					data,
					status
				} = await getTrainDetail({
					uuid: uuid
				});
				if (status === 200) {
					this.ruleForm = data.result;
					this.desc = data.result.desc
					this.onloadImageList.push(this.ruleForm.img)
				}
			},
			handleClickBack() {
				this.$router.back(-1);
			},
		}
	};
</script>

<style lang="less" scoped>
	.titles {
		color: #000;
		font-size: 20px;
	}

	.subtitle {
		color: #000;
		font-size: 18px;
		margin-bottom: 30px;
	}

	.el-icon-back {
		font-size: 22px !important;
		cursor: pointer;
	}

	.leftbg {
		display: flex;
		align-items: center;
	}

	.ava {
		width: 88px;
		height: 88px;
		border-radius: 50%;
		margin-right: 30px;
	}

	.lefttitle {
		font-size: 16px;
		color: #999;
		margin-bottom: 20px;
	}

	.leftval {
		margin-bottom: 20px;
		font-size: 16px;
		color: #000;
	}

	.imgsList {
		display: flex;
		align-items: center;
		flex-wrap: wrap;

		.imgItem {
			width: 32%;
			margin-right: 20px;
			margin-bottom: 20px;
		}
	}

	.operation-item {
		color: #409EFF;
		cursor: pointer;
		justify-content: center;
	}
</style>